import {
  DKButton,
  DKIcons,
  DKInputForm,
  DKLabel,
  DKLine,
  INPUT_TYPE,
  INPUT_VIEW_DIRECTION,
  showLoader,
  removeLoader,
  showToast,
  TOAST_TYPE,
} from "deskera-ui-library";
import React, { Component } from "react";
import Table from "../../services/table";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import RouteManager from "../../managers/RouteManager";
import { DEAL_STATUS_CODE, VISIBILITY_TYPE } from "../../constants/Enum";

export default class DealDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLostReasonPopup: false,
    };
    this.dealDetails = {};
    this.selectedStageID = 0;
  }
  componentDidMount() {
    RouteManager.setPresenter(this);
    this.getDealDetails();
  }
  getDealDetails = (showLoaderFlag = true) => {
    const dealColumns = {};
    TableManger.getTableColumns(TABLES.DEAL).forEach((column) => {
      dealColumns[column.columnCode] = column;
    });
    const pipelineNameColumnId = TableManger.getColumnId(
      TABLES.PIPELINE,
      COLUMN_CODE.PIPELINE.NAME
    );
    const pipelineStagesIdColumnId = TableManger.getColumnId(
      TABLES.PIPELINE,
      COLUMN_CODE.PIPELINE.STAGE_ID_S
    );
    const id = this.props.match.params.id;
    this.dealTableId = TableManger.getTableId(TABLES.DEAL);
    this.pipelineTableId = TableManger.getTableId(TABLES.PIPELINE);
    this.stageTableId = TableManger.getTableId(TABLES.STAGE);
    this.dealDetails = {};
    this.stageName = null;
    if (showLoaderFlag) showLoader("Loading Deals Data...");
    Table.getRecordById(id, this.dealTableId).then((data) => {
      if (data) {
        this.dealDetails = {
          id: id,
          name: data.cells[dealColumns[COLUMN_CODE.DEAL.NAME].id],
          closing_date:
            data.cells[dealColumns[COLUMN_CODE.DEAL.CLOSING_DATE].id],
          created_date: data.createdAt,
          stage_id: data.cells[dealColumns[COLUMN_CODE.DEAL.STAGE_ID].id],
          pipeline_id: data.cells[dealColumns[COLUMN_CODE.DEAL.PIPELINE_ID].id],
          amount: data.cells[dealColumns[COLUMN_CODE.DEAL.AMOUNT].id],
          contact_id: data.cells[dealColumns[COLUMN_CODE.DEAL.CONTACT_ID].id],
          deal_date: data.cells[dealColumns[COLUMN_CODE.DEAL.DEAL_DATE].id],
          owner_id: data.cells[dealColumns[COLUMN_CODE.DEAL.OWNER_ID].id],
          visibility: data.cells[dealColumns[COLUMN_CODE.DEAL.VISIBILITY].id],
          organization_id:
            data.cells[dealColumns[COLUMN_CODE.DEAL.ORGANIZATION_ID].id],
          reason: data.cells[dealColumns[COLUMN_CODE.DEAL.REASON].id],
          status: data.cells[dealColumns[COLUMN_CODE.DEAL.STATUS].id],
        };
      }
      removeLoader();
      this.setState({ dealDetails: this.dealDetails });
      Table.getRecordById(
        this.state.dealDetails.pipeline_id,
        this.pipelineTableId
      ).then((pipeline) => {
        let deal_age = Math.floor(
          (Date.parse(this.dealDetails.closing_date) -
            Date.parse(this.dealDetails.created_date)) /
            86400000
        );
        this.dealDetails = {
          ...this.dealDetails,
          pipeline_name: pipeline.cells[pipelineNameColumnId],
          stages_id: pipeline.cells[pipelineStagesIdColumnId],
          deal_age: deal_age === -1 ? 0 : deal_age,
        };
        const stageNameColumnId = TableManger.getColumnId(
          TABLES.STAGE,
          COLUMN_CODE.STAGES.NAME
        );
        Table.getRecordsByPage(null, null, this.stageTableId).then((res) => {
          if (res.data) {
            let stages = [];
            this.dealDetails.stages_id.forEach((stage) => {
              let matchedStage = res.data.find((rec) => rec._id === stage);
              stages.push(matchedStage);
              this.dealDetails = {
                ...this.dealDetails,
                stages: stages,
              };
              if (matchedStage._id === this.dealDetails.stage_id[0]) {
                this.stageName = matchedStage.cells[stageNameColumnId];
                this.dealDetails = {
                  ...this.dealDetails,
                  stage_name: matchedStage.cells[stageNameColumnId],
                };
              }
            });
          }
          this.selectedStageID = this.dealDetails.stages.findIndex(
            (stage) => this.dealDetails.stage_id[0] === stage._id
          );
          this.setState({ dealDetails: this.dealDetails });
        });
      });
    });
  };
  render() {
    return <>{this.state.dealDetails && this.getDetailPanel()}</>;
  }
  getDetailPanel = () => {
    return (
      <div className="parent-width align-items-start parent-height">
        <div className="row row-responsive justify-content-between">
          <DKLabel text="Deal Details" className="fw-m fs-l" />
        </div>
        {this.state.showLostReasonPopup && this.getDealLostReasonPopup()}
        <div
          className="row row-responsive parent-width align-items-stretch mt-m"
          style={{ width: window.innerWidth - 115, gap: "10px" }}
        >
          <div
            className="column bg-white border-radius-s border-box p-l shadow-s"
            style={{ width: "25%" }}
          >
            <div className="row row-responsive">
              <img src={DKIcons.ic_coupon} alt="" className="ic-s" />
              <DKLabel
                className="fw-s fs-l ml-m"
                text={this.state.dealDetails.name}
              />
            </div>
            <div className="row row-responsive mt-m">
              <DKLabel text="USD" className="fw-m fs-xl mr-m" />
              <DKLabel
                text={
                  this.state.dealDetails.amount
                    ? this.state.dealDetails.amount
                    : 0
                }
                className="fw-m fs-xl"
              />
            </div>
            <DKLine className="mt-xl" />
            <div className="column mt-xl parent-width">
              <DKLabel
                text="Current Stage"
                className="fs-m text-gray text-gray"
              />
              <DKLabel text={this.stageName} className="fw-m fs-m mt-s" />
              <div
                className="row parent-width mt-m stage-toggle-wrap"
                style={{ gap: 1 }}
              >
                {this.state.dealDetails.stages &&
                  this.state.dealDetails.stages.map((stage, index) => {
                    return (
                      <div
                        className={`parent-width cursor-hand stage-toggle-button bg-gray1 ${
                          index <= this.selectedStageID ? "selected-stage" : ""
                        }`}
                        onClick={() => {
                          this.selectedStageID = index;
                          this.updateState(stage);
                        }}
                        onMouseEnter={() => this.updateStageName(index)}
                        onMouseLeave={() => this.resetStageName()}
                        style={{ height: 20 }}
                      />
                    );
                  })}
              </div>
            </div>
            <div className="column mt-xl">
              <DKLabel text="Pipeline" className="fs-m text-gray" />
              <DKLabel
                text={this.state.dealDetails.pipeline_name}
                className="fw-m fs-m mt-s"
              />
            </div>
            <div className="column mt-xl">
              <DKLabel text="Deal Age" className="fs-m text-gray" />
              <DKLabel
                text={`${this.dealDetails.deal_age} ${
                  this.dealDetails.deal_age <= 0 ? "Day" : "Days"
                }`}
                className="fw-m fs-m mt-s"
              />
            </div>
            <div className="column mt-xl">
              <DKLabel text="Owner" className="fs-m text-gray" />
              <div className="row row-responsive mt-s">
                <img src={DKIcons.ic_user} alt="" className="ic-s mr-s" />
                <DKLabel
                  text={
                    this.state.dealDetails.owner_name
                      ? this.state.dealDetails.owner_name
                      : "-"
                  }
                  className="fw-m fs-m"
                />
              </div>
            </div>
            <div className="column mt-xl">
              <DKLabel text="Visibility" className="fs-m text-gray" />
              <div className="row row-responsive mt-s">
                <img src={DKIcons.ic_user} alt="" className="ic-s mr-s" />
                <DKLabel
                  text={this.getVisibility(this.state.dealDetails.visibility)}
                  className="fw-m fs-m"
                />
              </div>
            </div>
          </div>
          <div
            className="column  border-radius-s border-box p-l"
            style={{ width: "50%" }}
          >
            <div className="row row-responsive">
              <div className="tab row justify-content-around">
                {/* <DKButton title="Email" icon={DKIcons.ic_email} className="tablinks fs-m fw-m active" onClick={(event) => this.onTabClick(event, 'email')} style={{ borderRadius: 0 }} /> */}
                <DKButton
                  title="Activities"
                  icon={DKIcons.ic_email}
                  className="tablinks fs-m fw-m active"
                  onClick={(event) => this.onTabClick(event, "activities")}
                  style={{ borderRadius: 0 }}
                />
                {/* <DKButton title="Notes" icon={DKIcons.ic_books} className="tablinks fs-m fw-m" onClick={(event) => this.onTabClick(event, 'notes')} style={{ borderRadius: 0 }} />
                            <DKButton title="Log" icon={DKIcons.ic_logout} className="tablinks fs-m fw-m" onClick={(event) => this.onTabClick(event, 'log')} style={{ borderRadius: 0 }} /> */}
              </div>
            </div>
            <DKLine />
            <div className="row justify-content-center mt-l">
              {/* <div id="email" class="tabcontent parent-width" style={{ display: 'block' }}>
                            <Email onDataSubmit={(data) => this.handleEmail(data)} />
                        </div> */}

              <div
                id="activities"
                class="tabcontent parent-width"
                style={{ display: "block" }}
              >
                {/* <Activity module="DEAL" id={this.props.match.params.id} onDataSubmit={(data) => this.handleActivity(data)} /> */}
              </div>
              {/* <div id="notes" class="tabcontent parent-width">
                            <Notes onDataSubmit={(data) => this.handleNote(data)} />
                        </div>
                        <div id="log" class="tabcontent parent-width">
                            <h3>Log Component</h3>
                        </div> */}
            </div>
          </div>
          <div
            className="column bg-white border-radius-s border-box p-l shadow-s"
            style={{ width: "25%" }}
          >
            {this.state.dealDetails.status !== DEAL_STATUS_CODE.WON && (
              <div className="row row-responsive">
                <img src={DKIcons.ic_coupon} alt="" className="ic-s" />
                <DKLabel className="fw-m fs-l ml-m" text={"Closed Deal"} />
                {this.state.dealDetails.status === DEAL_STATUS_CODE.LOST && (
                  <div className="bg-chip-red ml-r p-v-xs p-h-s  border-radius-l">
                    Deal Lost
                  </div>
                )}
              </div>
            )}
            {this.state.dealDetails.status !== DEAL_STATUS_CODE.WON &&
              this.state.dealDetails.status !== DEAL_STATUS_CODE.LOST && (
                <div className="row row-responsive mt-m parent-width">
                  <div className="row parent-width">
                    <DKButton
                      title="👍 Deal Won"
                      className="bg-app text-white border-m mr-m parent-width"
                      onClick={() => this.markDealAsWon()}
                    />
                  </div>
                  <div className="row parent-width justify-content-end">
                    <DKButton
                      title="👎 Deal Lost"
                      className="bg-red text-white border-m parent-width"
                      onClick={() =>
                        this.setState({ showLostReasonPopup: true })
                      }
                    />
                  </div>
                </div>
              )}
            {this.state.dealDetails.status === DEAL_STATUS_CODE.LOST && (
              <div className="column mt-m parent-width">
                <DKLabel className="fw-s fs-m" text={"Contact Reject Reason"} />
                <DKLabel
                  className="fw-s fs-m text-gray mt-m"
                  text={this.state.dealDetails.reason}
                />
              </div>
            )}
            {this.state.dealDetails.status !== DEAL_STATUS_CODE.WON && (
              <DKLine className="mt-xl" />
            )}
            <div className="row row-responsive mt-xl">
              <img src={DKIcons.ic_coupon} alt="" className="ic-s" />
              <DKLabel className="fw-s fs-l ml-m" text={"Linked Contacts"} />
            </div>
            <div className="column parent-width border-radius-m bg-gray1 p-r border-box mt-xxl border-m">
              <div className="row row-responsive mt-s">
                <img src={DKIcons.ic_user} alt="" className="ic-s mr-s" />
                <DKLabel
                  text={
                    this.state.dealDetails.contact_name
                      ? this.state.dealDetails.contact_name
                      : "No Contact Linked"
                  }
                  className="fw-m fs-m"
                />
              </div>
              <DKLabel
                text={
                  this.state.dealDetails.label
                    ? this.state.dealDetails.label
                    : "No Label"
                }
                className="fs-m ml-xl mt-l"
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  resetStageName = () => {
    this.selectedStageID = this.state.dealDetails.stages.findIndex(
      (stage) => this.state.dealDetails.stage_id[0] === stage._id
    );
    this.setState({
      ...this.state.dealDetails,
      stage_name: this.state.dealDetails.stage_name,
    });
    this.stageName = this.state.dealDetails.stage_name;
  };
  updateStageName = (index) => {
    const stageNameColumnId = TableManger.getColumnId(
      TABLES.STAGE,
      COLUMN_CODE.STAGES.NAME
    );
    this.setState({
      ...this.state.dealDetails,
      stage_name: this.state.dealDetails.stages[index].cells[stageNameColumnId],
    });
    this.selectedStageID = index;
    this.stageName = this.state.dealDetails.stages[index].cells[
      stageNameColumnId
    ];
  };
  getVisibility = (id) => {
    return VISIBILITY_TYPE["VISIBLITY_" + id];
  };
  updateState = (stage) => {
    const stageColumnId = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.STAGE_ID
    );
    const stageWonColumnId = TableManger.getColumnId(
      TABLES.STAGE,
      COLUMN_CODE.STAGES.WON_STAGE
    );
    const stageLostColumnId = TableManger.getColumnId(
      TABLES.STAGE,
      COLUMN_CODE.STAGES.LOST_STAGE
    );
    const dealStatusColumnId = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.STATUS
    );
    const dealReasonColumnId = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.REASON
    );
    let wonDeal = this.dealDetails.stages.find(
      (stage) => stage.cells[stageWonColumnId]
    );
    let lostDeal = this.dealDetails.stages.find(
      (stage) => stage.cells[stageLostColumnId]
    );
    let status = 0;
    if (wonDeal._id === stage._id) {
      this.markDealAsWon();
    } else if (lostDeal._id === stage._id) {
      this.setState({ showLostReasonPopup: true });
    } else {
      let data = {
        [stageColumnId]: [stage._id],
        [dealStatusColumnId]: status,
        [dealReasonColumnId]: "",
      };
      Table.updateRecord(data, this.dealDetails.id, this.dealTableId).then(
        (data) => {
          showToast("Deal Updated Successfully.", TOAST_TYPE.SUCCESS);
          this.getDealDetails(false);
        }
      );
    }
  };
  handleNote = (data) => {};
  handleEmail = (data) => {};
  handleActivity = (data) => {};
  getDealLostReasonPopup = () => {
    const direction = INPUT_VIEW_DIRECTION.VERTICAL;
    const dealReasonColumnId = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.REASON
    );
    const fields = [
      {
        key: "reason",
        title: "Contact Reject Reason",
        type: INPUT_TYPE.TEXT,
        value: "",
        requestKey: dealReasonColumnId,
        icon: DKIcons.ic_coupon,
      },
    ];
    return (
      <div className="transparent-background parent-height">
        <div className="popup-window" style={{ maxWidth: 450 }}>
          <div className="column parent-width">
            <div className="">
              <DKInputForm
                className=""
                style={{ width: 415 }}
                direction={direction}
                title="Deal Lost"
                fields={fields}
                dateFormat="MMM dd, yyyy"
                onCancel={() => {
                  this.setState({ showLostReasonPopup: false });
                }}
                onSubmit={(data) => {
                  this.markDealAsLost(data);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  markDealAsWon = () => {
    const stageWonColumnId = TableManger.getColumnId(
      TABLES.STAGE,
      COLUMN_CODE.STAGES.WON_STAGE
    );
    const dealStageColumnId = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.STAGE_ID
    );
    const dealStatusColumnId = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.STATUS
    );
    this.setState({ showLostReasonPopup: false });
    let wonDeal = this.dealDetails.stages.find(
      (stage) => stage.cells[stageWonColumnId]
    );
    let dataToSend = {
      [dealStageColumnId]: [wonDeal._id],
      [dealStatusColumnId]: 1,
    };
    Table.updateRecord(dataToSend, this.dealDetails.id, this.dealTableId).then(
      (data) => {
        showToast("Deal Marked As Won.", TOAST_TYPE.SUCCESS);
        this.getDealDetails(false);
      }
    );
  };
  markDealAsLost = (data) => {
    const stageLostColumnId = TableManger.getColumnId(
      TABLES.STAGE,
      COLUMN_CODE.STAGES.LOST_STAGE
    );
    const dealStageColumnId = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.STAGE_ID
    );
    const dealReasonColumnId = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.REASON
    );
    const dealStatusColumnId = TableManger.getColumnId(
      TABLES.DEAL,
      COLUMN_CODE.DEAL.STATUS
    );
    this.setState({ showLostReasonPopup: false });
    let lostDeal = this.dealDetails.stages.find(
      (stage) => stage.cells[stageLostColumnId]
    );
    let dataToSend = {
      [dealStageColumnId]: [lostDeal._id],
      [dealReasonColumnId]: data[0].value,
      [dealStatusColumnId]: 2,
    };
    Table.updateRecord(dataToSend, this.dealDetails.id, this.dealTableId).then(
      (data) => {
        showToast("Deal Marked As Lost.", TOAST_TYPE.SUCCESS);
        this.getDealDetails(false);
      }
    );
  };
  onTabClick = (evt, cityName) => {
    let i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
  };
}
